export default "__VITE_ASSET__DVus14Sr__"